import {MarketDetails} from '@/pages/(shared)/market/components/marketDetails';
import {MarketDetailsProvider} from '@/pages/(shared)/market/providers/marketDetailsProvider';

/** MarketDetailsPage component */
export const MarketDetailsPage = () => {
  return (
    <MarketDetailsProvider>
      <MarketDetails />
    </MarketDetailsProvider>
  );
};
